import React, { useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { T } from "../theme";

// The admin gate and header around the list and the workspace.
// Client-side gate only (docs/SECURITY.md): the value is in the bundle.
const ADMIN_PW = process.env.REACT_APP_ADMIN_PW;
export const ADMIN_FLAG = "thread-hub:admin";
export const isAdminSession = () => { try { return sessionStorage.getItem(ADMIN_FLAG) === "1"; } catch (e) { return false; } };

const inputStyle = { width: "100%", padding: "12px 16px", fontSize: 14, border: `1px solid ${T.borderSubtle}`, borderRadius: T.radiusMd, outline: "none", fontFamily: T.fontSans, background: T.bgSurface, color: T.root };

export default function AdminShell() {
  const [authed, setAuthed] = useState(isAdminSession);
  const [pw, setPw] = useState("");
  const [pwError, setPwError] = useState(false);
  const location = useLocation();
  const login = () => {
    if (pw === ADMIN_PW) { setAuthed(true); setPwError(false); try { sessionStorage.setItem(ADMIN_FLAG, "1"); } catch (e) {} }
    else setPwError(true);
  };
  if (!authed) return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: T.bgInverse, fontFamily: T.fontSans }}>
      <div className="login-card" style={{ background: T.canvas, borderRadius: T.radiusLg, padding: 40, width: 380, textAlign: "center", boxShadow: T.shadowLg }}>
        <div style={{ color: T.canopy, fontSize: 11, fontWeight: 600, letterSpacing: "0.12em", textTransform: "uppercase", marginBottom: 8 }}>Thread Hub</div>
        <h2 style={{ fontSize: 22, fontWeight: 700, color: T.root, marginBottom: 24 }}>Admin</h2>
        <input type="password" value={pw} onChange={e => { setPw(e.target.value); setPwError(false); }} onKeyDown={e => e.key === "Enter" && login()} placeholder="Password" autoComplete="off" data-1p-ignore="true" data-lpignore="true" style={{ ...inputStyle, border: `1px solid ${pwError ? T.statusOff : T.borderSubtle}`, marginBottom: 12 }} />
        {pwError && <p style={{ color: T.statusOff, fontSize: 12, marginBottom: 12 }}>Incorrect password</p>}
        <button onClick={login} style={{ width: "100%", padding: "12px 0", fontSize: 14, fontWeight: 600, color: T.fgOnDark, background: T.root, border: "none", borderRadius: T.radiusMd, cursor: "pointer", fontFamily: T.fontSans }}>Sign in</button>
      </div>
    </div>
  );
  const path = location.pathname;
  const onOverview = path === "/admin" || path === "/admin/";
  const onEngagements = !onOverview; // the list and every workspace
  return (
    <div style={{ minHeight: "100vh", background: T.bgSurface, fontFamily: T.fontSans }}>
      <div className="admin-header" style={{ background: T.bgInverse, padding: "10px 40px 0" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div style={{ color: T.fgOnDark, fontSize: 15, fontWeight: 700 }}><span style={{ display: "block", color: T.canopy, fontSize: 10, fontWeight: 600, letterSpacing: "0.12em", textTransform: "uppercase" }}>Thread Hub</span>Admin</div>
        </div>
        <nav style={{ display: "flex", gap: 4, marginTop: 6 }}>
          {[["/admin", "Overview", onOverview], ["/admin/engagements", "Engagements", onEngagements]].map(([to, label, on]) => (
            <Link key={to} to={to} style={{ padding: "8px 14px", fontSize: 13, fontWeight: 600, textDecoration: "none", color: on ? T.fgOnDark : T.canopy, borderBottom: `2px solid ${on ? T.threadline : "transparent"}` }}>{label}</Link>
          ))}
        </nav>
      </div>
      <Outlet />
    </div>
  );
}
